export const healthData = [
  {
    subject: "sitAndReach",
    data: [
      {
        status: "danger",
        value: (
          <div>
            <span>[남 / 여]</span>
            초5 : -5.1~-4.1 / -0.1~0.9
            <br />
            초6 : -5.1~-4.1 / -0.1~1.9
            <br />
            중1 : -5.1~-4.1 / -0.1~1.9
            <br />
            중2 : -5.1~-4.1 / -0.1~1.9
            <br />
            중3 : -5.1~-3.1 / -0.1~1.9
            <br />
            고1 : -3.1~-2.1 / -0.1~1.9
            <br />
            고2 : -3.1~0.0 / -0.1~4.9
            <br />
            고3 : -3.1~0.0 / -0.1~4.9
          </div>
        ),
        label: "아주낮음",
      },
      {
        status: "warn",
        value: (
          <div>
            <span>[남 / 여]</span>
            초5 : -4.0~0.9 / 1.0~4.9
            <br />
            초6 : -4.0~0.9 / 2.0~4.9
            <br />
            중1 : -4.0~1.9 / 2.0~7.9
            <br />
            중2 : -4.0~1.9 / 2.0~7.9
            <br />
            중3 : -3.0~2.5 / 2.0~7.9
            <br />
            고1 : -2.0~3.9 / 2.0~7.9
            <br />
            고2 : 0.1~4.9 / 5.0~8.9
            <br />
            고3 : 0.1~5.9 / 5.0~8.9
          </div>
        ),
        label: "낮음",
      },
      {
        status: "good",
        value: (
          <div>
            <span>[남 / 여]</span>
            초5 : 1.0~4.9 / 5.0~6.9
            <br />
            초6 : 1.0~4.9 / 5.0~9.9
            <br />
            중1 : 2.0~5.9 / 8.0~10.9
            <br />
            중2 : 2.0~6.9 / 8.0~10.9
            <br />
            중3 : 2.6~6.9 / 8.0~10.9
            <br />
            고1 : 4.0~8.9 / 8.0~10.9
            <br />
            고2 : 5.0~10.9 / 9.0~11.9
            <br />
            고3 : 6.0~10.9 / 9.0~11.9
          </div>
        ),
        label: "보통",
      },
      {
        status: "good",
        value: (
          <div>
            <span>[남 / 여]</span>
            초5 : 5.0~7.9 / 7.0~9.9
            <br />
            초6 : 5.0~7.9 / 10.0~13.9
            <br />
            중1 : 6.0~9.9 / 11.0~14.9
            <br />
            중2 : 7.0~9.9 / 11.0~14.9
            <br />
            중3 : 7.0~9.9 / 11.0~15.9
            <br />
            고1 : 9.0~12.9 / 11.0~15.9
            <br />
            고2 : 11.0~15.9 / 12.0~16.9
            <br />
            고3 : 11.0~15.9 / 12.0~16.9
          </div>
        ),
        label: "높음",
      },
      {
        status: "good",
        value: (
          <div>
            <span>[남 / 여]</span>
            초5 : 8.0~18.0 / 10.0~22.0
            <br />
            초6 : 8.0~18.0 / 14.0~26.0
            <br />
            중1 : 10.0~25.0 / 15.0~28.0
            <br />
            중2 : 10.0~25.0 / 15.0~28.0
            <br />
            중3 : 10.0~25.0 / 16.0~28.0
            <br />
            고1 :13.0~28.0 / 16.0~28.0
            <br />
            고2 :16.0~28.0 / 17.0~28.0
            <br />
            고3 : 16.0~28.0 / 17.0~28.0
          </div>
        ),
        label: "아주높음",
      },
    ],
  },
  {
    subject: "gribStrength",
    data: [
      {
        status: "danger",
        value: (
          <div>
            <span>[남 / 여]</span>
            초4 : 8.9~11.4 / 8.5~10.4
            <br />
            초5 : 9.9~12.4 / 10.6~11.9
            <br />
            초6 : 11.2~14.9 / 10.0~13.9
            <br />
            중1 : 14.4~16.4 / 11.9~13.9
            <br />
            중2 : 19.1~21.9 / 13.0~13.9
            <br />
            중3 : 19.1~24.9 / 14.9~15.9
            <br />
            고1 : 25.5~28.9 / 16.0~16.4
            <br />
            고2 : 28.5~30.9 / 17.6~17.9
            <br />
            고3 : 30.5~30.9 / 17.6~17.9
          </div>
        ),
        label: "아주낮음",
      },
      {
        status: "warn",
        value: (
          <div>
            <span>[남 / 여]</span>
            초4 : 11.5~14.9 / 10.5~13.4
            <br />
            초5 : 12.5~16.9 / 12.0~15.4
            <br />
            초6 : 15.0~18.9 / 14.0~18.9
            <br />
            중1 : 16.5~22.4 / 14.0~18.9
            <br />
            중2 : 22.0~28.4 / 14.0~19.4
            <br />
            중3 : 25.0~32.9 / 16.0~19.4
            <br />
            고1 : 29.0~35.4 / 16.5~22.9
            <br />
            고2 : 31.0~38.9 / 18.0~24.9
            <br />
            고3 : 31.0~38.9 / 18.0~24.9
          </div>
        ),
        label: "낮음",
      },
      {
        status: "good",
        value: (
          <div>
            <span>[남 / 여]</span>
            초4 : 15.0~18.4 / 13.5~17.9
            <br />
            초5 : 17.0~22.9 / 15.5~18.9
            <br />
            초6 : 19.0~26.4 / 19.0~21.9
            <br />
            중1 : 22.5~29.9 / 19.0~22.9
            <br />
            중2 : 28.5~36.9 / 19.5~25.4
            <br />
            중3 : 33.0~40.4 / 19.5~27.4
            <br />
            고1 : 35.5~42.4 / 23.0~28.9
            <br />
            고2 : 39.0~45.9 / 25.0~29.4
            <br />
            고3 : 39.0~45.9 / 25.0~29.4
          </div>
        ),
        label: "보통",
      },
      {
        status: "good",
        value: (
          <div>
            <span>[남 / 여]</span>
            초4 : 18.5~30.9 / 18.0~28.9
            <br />
            초5 : 23.0~30.9 / 19.0~28.9
            <br />
            초6 : 26.5~34.9 / 22.0~32.9
            <br />
            중1 : 30.0~41.9 / 23.0~35.9
            <br />
            중2 : 37.0~44.4 / 25.5~35.9
            <br />
            중3 : 40.5~48.4 / 27.5~35.9
            <br />
            고1 : 42.5~60.9 / 29.0~35.9
            <br />
            고2 : 46.0~60.9 / 29.5~37.4
            <br />
            고3 : 46.0~63.4 / 29.5~37.4
          </div>
        ),
        label: "높음",
      },
      {
        status: "good",
        value: (
          <div>
            <span>[남 / 여]</span>
            초4 : 31.0~36.0 / 29.0~33.6
            <br />
            초5 : 31.0~37.0 / 29.0~35.0
            <br />
            초6 : 35.0~39.4 / 33.0~39.0
            <br />
            중1 : 42.0~46.0 / 36.0~38.0
            <br />
            중2 : 44.5~47.0 / 36.0~38.0
            <br />
            중3 : 48.5~50.0 / 36.0~38.0
            <br />
            고1 : 61.0~62.5 / 36.0~38.0
            <br />
            고2 : 61.0~65.0 / 37.5~38.2
            <br />
            고3 : 63.5~68.4 / 37.5~38.2
          </div>
        ),
        label: "아주높음",
      },
    ],
  },
  {
    subject: "bmi",
    data: [
      {
        status: "warn",
        value: "~18.5",
        label: "저체중",
      },
      {
        status: "good",
        value: "18.5~23",
        label: "정상",
      },
      {
        status: "warn",
        value: "23~25",
        label: "과체중",
      },
      {
        status: "warn",
        value: "25~30",
        label: "경도비만",
      },
      {
        status: "danger",
        value: "30~",
        label: "중등도 비만",
      },
    ],
  },
  {
    subject: "skeletalMuscleMass",
    data: [
      {
        status: "warn",
        value: "평균 미만",
        label: "평균 미만",
      },
      {
        status: "good",
        value: (
          <div>
            <span>[남자]</span>
            몸무게 30kg 기준 : 13.5kg
            <br />
            몸무게 40kg 기준 : 18kg
            <br />
            몸무게 50kg 기준 : 22.5kg
            <br />
            몸무게 60kg 기준 : 27kg
            <br />
            몸무게 70kg 기준 : 31.5kg
            <br />
            몸무게 80kg 기준 : 36kg
            <br />
            <br />
            <span>[여자]</span>
            몸무게 30kg 기준 : 10.8kg
            <br />
            몸무게 40kg 기준 : 14.4kg
            <br />
            몸무게 50kg 기준 : 18kg
            <br />
            몸무게 60kg 기준 : 21.6kg
            <br />
            몸무게 70kg 기준 : 25.2kg
            <br />
            몸무게 80kg 기준 : 28.8kg
            <br />
          </div>
        ),
        label: "평균",
      },
      {
        status: "warn",
        value: "평균 이상",
        label: "평균 이상",
      },
    ],
  },
  {
    subject: "bodyFatPercentage",
    data: [
      {
        status: "warn",
        value: (
          <>
            남자: 11.9 이하
            <br />
            여자: 14.9 이하
          </>
        ),
        label: "마름",
      },
      {
        status: "good",
        value: (
          <>
            남자: 12
            <br />
            여자: 15
          </>
        ),
        label: "정상",
      },
      {
        status: "warn",
        value: (
          <>
            남자: 15
            <br />
            여자: 27
          </>
        ),
        label: "과체중",
      },
      {
        status: "warn",
        value: (
          <>
            남자: 25
            <br />
            여자: 32
          </>
        ),
        label: "경도비만",
      },
      {
        status: "danger",
        value: (
          <>
            남자: 33 이상
            <br />
            여자: 40 이상
          </>
        ),
        label: "고도비만",
      },
    ],
  },
];
